/*@jsxRuntime automatic @jsxImportSource react*/
import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
export const frontmatter = undefined;
import Intersection from "/components/marketing/diagrams/websemaphore-intersection";
function _createMdxContent(props) {
  const _components = Object.assign({
    h1: "h1",
    p: "p",
    h2: "h2",
    table: "table",
    thead: "thead",
    tr: "tr",
    th: "th",
    tbody: "tbody",
    td: "td",
    a: "a"
  }, _provideComponents(), props.components);
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: "Technology Landscape"
    }), "\n", _jsx(_components.p, {
      children: "There are many components and tools involved in the vast API integration landscape, so here's some orientational comparison."
    }), "\n", _jsx(Intersection, {}), "\n", _jsx(_components.p, {
      children: "WebSemaphore's featureset primarily intersects with that of message brokers, workflow orchestration tools, integration platrofms and distributed synchronization tools."
    }), "\n", _jsx(_components.h2, {
      children: "Quick overview of solution categories"
    }), "\n", _jsxs(_components.table, {
      children: [_jsx(_components.thead, {
        children: _jsxs(_components.tr, {
          children: [_jsx(_components.th, {
            children: "Category"
          }), _jsx(_components.th, {
            children: "Description"
          })]
        })
      }), _jsxs(_components.tbody, {
        children: [_jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Message Brokers"
          }), _jsx(_components.td, {
            children: "Centralized systems facilitating communication between distributed components, ensuring reliable message delivery."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Workflow Orchestration"
          }), _jsx(_components.td, {
            children: "Coordinating and automating tasks in a predefined sequence, ensuring seamless execution of complex processes."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Integration Platforms"
          }), _jsx(_components.td, {
            children: "Software solutions connecting disparate systems, applications, and services to enable data flow and process automation."
          })]
        }), _jsxs(_components.tr, {
          children: [_jsx(_components.td, {
            children: "Distributed Synchronization"
          }), _jsx(_components.td, {
            children: "Coordinating activities across multiple nodes or components in a distributed system to maintain consistency and avoid conflicts."
          })]
        })]
      })]
    }), "\n", _jsx("br", {}), "\n", _jsx("br", {}), "\n", _jsxs(_components.p, {
      children: ["Tools in these categories may be providing a basis to the solution, however none of them addresses concurrency in the context of systems integration\nunder near real-time conditions as its primary focus. In other words, although ", _jsx(_components.a, {
        href: "https://wiki.c2.com/?ThereIsMoreThanOneWayToDoIt",
        children: "there is more than one way to do it"
      }), ", WebSemapohre is aiming to be\nthe most economical option from both effort and budget perspectives."]
    }), "\n", _jsxs(_components.p, {
      children: ["If you need support for your specific platform/stack ", _jsx(_components.a, {
        href: "/contact",
        children: "contact us"
      }), "."]
    })]
  });
}
function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = Object.assign({}, _provideComponents(), props.components);
  return MDXLayout ? _jsx(MDXLayout, Object.assign({}, props, {
    children: _jsx(_createMdxContent, props)
  })) : _createMdxContent(props);
}
export default MDXContent;
